import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/data";
import { toast } from "sonner";

export default function Newsletter({ variant = "footer" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're in.", { description: "We'll write when there's something worth the walk." });
      setEmail("");
    } catch (err) {
      toast.error("Please enter a valid email.");
    } finally {
      setLoading(false);
    }
  };

  const dark = variant === "footer";

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="w-full">
      <div className={`flex items-center gap-2 border-b ${dark ? "border-cream/30" : "border-charcoal/30"} pb-2`}>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com"
          data-testid="newsletter-email-input"
          className={`w-full bg-transparent font-manrope text-lg outline-none placeholder:opacity-50 ${dark ? "text-cream placeholder:text-cream" : "text-charcoal"}`}
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="newsletter-submit"
          className={`group flex flex-shrink-0 items-center gap-2 font-manrope text-sm ${dark ? "text-cream" : "text-charcoal"} disabled:opacity-50`}
        >
          {loading ? "…" : "Join"} <ArrowRight className="hover-arrow h-4 w-4" />
        </button>
      </div>
    </form>
  );
}
